export const admissionsOfficeHeaderSelectConst = [
  {
    id: "admission-letter",
    title: "Admission letter",
    mass: [{ name: "Ukraine" }, { name: "Malta" }, { name: "Poland" }],
  },
  {
    id: "admission-letter-2",
    title: "Admission letter 2",
    mass: [{ name: "Ukraine 2" }, { name: "Malta 2" }, { name: "Poland 2" }],
  },
  {
    id: "admission-letter-3",
    title: "Admission letter 3",
    mass: [{ name: "Ukraine 3" }, { name: "Malta 3" }, { name: "Poland 3" }],
  },
];

export const admissionsOfficeHeaderTabsConst = [
  {
    id: "ukraine",
    title: "Ukraine",
    mass: [
      { name: "Admission letter UA", slug: "admission" },
      { name: "Invoice letter UA", slug: "invoice" },
      { name: "Payment confirmation letter UA", slug: "payment" },
      { name: "Letter of acknowledgement UA", slug: "acknowledgement" },
      { name: "Request Letter UA", slug: "request" },
    ],
  },
  {
    id: "malta",
    title: "Malta",
    mass: [
      { name: "Admission letter MT", slug: "admission" },
      { name: "Student Letter MT", slug: "student" },
      { name: "Invoice letter MT", slug: "invoice" },
      { name: "Payment confirmation letter MT", slug: "payment" },
      { name: "Certificates MT", slug: "certificates" },
      { name: "Letter of acknowledgement MT", slug: "acknowledgement" },
    ],
  },
  {
    id: "poland",
    title: "Poland",
    mass: [
      { name: "Admission letter PL", slug: "admission" },
      { name: "Invoice letter PL", slug: "invoice" },
      { name: "Payment confirmation letter PL", slug: "payment" },
      { name: "Letter of acknowledgement PL", slug: "acknowledgement" },
    ],
  },
];

export const admissionOfficeWhoseDoc = [
  "FR IEU Malte",
  "Edward Wilson",
  "Zimbabwe IEU Malta",
  "Univer Malta campus",
  "Cristy Bishop",
  "Victoria Smith",
  "Isaac Davis",
  "Olivia IEU",
  "Maryna Koval",
  "Karina Pinchuk",
  "Zoia Kozachenko",
  "RUSVUZ st",
  "RUSVUZ ag",
  "RECAS st",
  "RECAS ag",
  "REC st",
  "REC ag",
  "REG st",
  "REG ag",
  "EDUGAIN ag",
  "EDUGAIN st",
  "IEU Pl ag",
  "IEU Malta st",
  "IEU Pl st",
  "Anna Ivchenko",
  "IEU UA st",
  "IEU UA ag",
  "UEG",
  "IEU Pakistan",
  "12Consultants",
  "UES",
  "Jasper Jones",
];
